import dialogs from '../common/dialogs.js'
import AssistClasses from '../assist/AssistClasses.js'
import people from './index.js'

class Strategy extends AssistClasses.Strategy {
  constructor (cxt) {
    super(cxt)
    this.pProps = null
  }
  setContext (cxt) {
    this.context = cxt
  }
  setParentProps (pProps) {
    this.pProps = pProps
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createModelFromData (data) {
    if (data && data.model) {
      return this.createModelFromJSON(data.model)
    }
    return this.createDefaultModel(this.pProps)
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }
  fetchData (itemId) {
    return new Promise((resolve, reject) => {
      if (itemId) {
        people.getIndividualDoc(null, itemId).then((data) => {
          resolve(data)
        })
      } else {
        resolve(null)
      }
    })
  }
  updateData (itemId, model) {
    let item = {
      id: itemId,
      clientIndividualId: this.pProps ? this.pProps.id : null,
      type: this.getTypeCode(),
      model: model
    }
    return new Promise((resolve, reject) => {
      this.context.$store.dispatch('updatePeopleDoc', item).then(id => {
        resolve(id)
      })
    })
  }
  deleteData (itemId, model) {
    return new Promise((resolve, reject) => {
      dialogs.confirm(this.context,
        'Подтвердите',
        `Удалить запись о документе ?`,
          (self) => {
            self.$store.dispatch('deletePeopleDocs', {ids: [itemId]})
              .then(() => resolve())
          })
    })
  }
  viewNumber (model) {
    return ''
  }
  viewTitle (model) {
    return `${this.getTypeName()}: ${this.viewNumber(model)}`
  }
}

export default {
  Strategy
}



// WEBPACK FOOTER //
// ./src/components/people/DocAbstract.js